const styles = (theme) => ({
	container: {
		width: "100%",
		height: "100vh",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		flexDirection: "row",
		backgroundColor: "#000933"
	},
	form: {
		display: 'flex',
		flexDirection: 'column',
		gap: 3,
		justifyContent: 'center',
		alignItems: 'center',
		height: "70vh",

	},


	paperForm: {
		minHeight: "600px",
		//minHeight: "500px",
		minWidth: "400px",
		//padding: "20px 40px",
		paddingX: 10,
		width: { xs: "100vw", md: "50vw", lg: "45vw" },
		alignItems: "center",
		justifyContent: "center",
		flexDirection: "column",
		display: "flex",
		backgroundColor: "white",
		borderRadius: "10px",
		maxWidth: "550px",
		//backgroundColor: theme.palette.ligth.background.paper,
	},
	titleImage: {
		fontSize: "3em",
		fontFamily: "Rubik",
		fontStyle: "normal",
		fontWeight: "500",
		lineHeight: "1em",
		width: "60%",
	},
	subTitleImage: { fontSize: "1.25em", width: "60%", fontWeight: "300" },
	boxLogo: {
		width: "100%",
		flexDirection: "column",
		alignItems: "center",
	},
	logo: { height: "auto", width: "auto" },
	textField: {
		width: "100%",
	},
	button: {
		width: "100%",
		borderRadius: "5px",
		//marginTop: "15px",
		height: "50px",
		textTransform: "none",
		fontSize: 18,
		color: "white",
	},
	boxForm: {
		position: "relative",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "flex-start",
		flex: { xs: 0, md: 1 },
		flex: 1,
		width: "100%",
		maxWidth: "550px",
	},
	titleForm: {
		display: "flex",
		flexDirection: "column",
		alignItems: "flex-start",
		gap: 0.5,
		alignSelf: "stretch",
		marginTop: 3,
	},
	boxTextFields: {
		display: "flex",
		padding: "32px 0px",
		flexDirection: "column",
		alignItems: "center",
		gap: 4,
		alignSelf: "stretch",
	},
	boxButtonAndLinks: {
		display: "flex",
		height: "max-content",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		gap: 2,
		alignSelf: "stretch",
	},
	link: {
		display: "flex",
		padding: "0px 0px 12px 0px",
		justifyContent: { xs: "center", md: "space-between" },
		alignItems: "center",
		flexWrap: "wrap",
		flexDirection: "row",
		width: "100%",
		gap: 1,
	},
	linkIcons: {
		display: "flex",
		justifyContent: "center",
		width: "100%",
		gap: 1,
	},
	icons: {
		color: "text.primary",
	},
	img: {
		height: "auto",
		width: "180px",
	},
});

export default styles;
